import styled from "styled-components";


export const PersonalDetailsWrapper = styled.div`
padding:28px 33px 41px 33px;
height: 100%;
display: flex;
justify-content: flex-start;
align-items: flex-start;
flex-direction: column;
@media (max-width: 600px) {
  padding: 16px;
}
`
export const PersonalDetailsTitle = styled.span`
color: var(--font-color-blue002e5c);
font-size: var(--general-header-font-size);
font-style: normal;
font-weight: var(--general-header-font-weight);
line-height: 32px;
padding-bottom: 8px;
display: flex;
justify-content: space-between;
align-items: center;
border-bottom: 1px dashed rgba(0, 46, 92, 0.10);
width: 100%;
margin-bottom: 24px;
@media (max-width: 600px) {
  margin-bottom: 12px;
}
span{
padding-right: 8px;
}
`
export const GridItem = styled.div`

`

export const ReserveLoginButton = styled.button`
  background: transparent !important;
  color: var(--font-color-blue2555ef);
  border: none;
  font-weight: var(--general-button-font-weight);
  font-size: var(--general-button-font-size);
  line-height: 21px;
  text-align: center;
  cursor: pointer;
  text-decoration: underline;
`;